const userRoutes = [
    {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('../../views/User/userInfo.vue'),
        meta: { title: 'menu.accountInfo' }
    }
]

export default userRoutes
